import React from 'react';
import { Outlet } from 'react-router-dom';

const PaymentTrackerContent = () => {
  return <Outlet />;
};

export default PaymentTrackerContent;
